import ZZZ_DB from './storage';

export default ZZZ_DB;
